var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21425 11.619H1.95238C1.54087 11.619 1.19593 11.4798 0.917558 11.2014C0.639186 10.9231 0.5 10.5781 0.5 10.1666C0.5 9.75512 0.639186 9.41018 0.917558 9.13181C1.19593 8.85344 1.54087 8.71425 1.95238 8.71425H9.21425V1.45238C9.21425 1.04087 9.35344 0.69593 9.63181 0.417558C9.91018 0.139186 10.2551 0 10.6666 0C11.0781 0 11.4231 0.139186 11.7014 0.417558C11.9798 0.69593 12.119 1.04087 12.119 1.45238V8.71425H19.3809C19.7924 8.71425 20.1373 8.85344 20.4157 9.13181C20.6941 9.41018 20.8333 9.75512 20.8333 10.1666C20.8333 10.5781 20.6941 10.9231 20.4157 11.2014C20.1373 11.4798 19.7924 11.619 19.3809 11.619H12.119V18.8809C12.119 19.2924 11.9798 19.6373 11.7014 19.9157C11.4231 20.1941 11.0781 20.3333 10.6666 20.3333C10.2551 20.3333 9.91018 20.1941 9.63181 19.9157C9.35344 19.6373 9.21425 19.2924 9.21425 18.8809V11.619Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.a6c7f2cf333a2765080c71a19cf0fed1.svg";
export { ForwardRef as ReactComponent };